export enum IpaAdminTabId {
    PreferredStatus = 'preferred-status-tab',
}
